<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>{{ campaignDescription.campaign_name }} - Review Fields Data</h3>
        </vs-col>
      </vs-row>


      <template v-for="(changes, key, index) in review_changes">


        <vs-row>
          <vs-col vs-type="flex" vs-w="3" class="pb-5 pt-10">
            <h6 class="mr-5">Company Name : </h6> {{ changes['company_name'] }}
          </vs-col>
        </vs-row>
        <vs-row>
        </vs-row>

        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row class="pb-4">
              <vs-col vs-w="4">
                <h6>Field Name </h6>

                <template v-for="(value, key, index) in changes">
                  <div class="p-6" style="height:110px;" v-if="selected_other_field[0].includes(key)">
                    {{ key }}
                  </div>
                </template>
              </vs-col>
              <vs-col vs-w="3">
                <h6>Uploaded Value </h6>

                <template v-for="(value, key, index) in changes">
                  <div class="p-6" style="height:110px;" v-if="selected_other_field[0].includes(key)">
                    {{ value }} </div>
                </template>
              </vs-col>
              <vs-col vs-w="5">
                <!-- <template v-for="(value, key, index) in changes">
                  <div class="p-6" style="height:110px;"
                    v-if="selected_other_field.includes(key)">
                    {{ value }} </div>
                </template> -->

              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-divider class="mt-5" />

      </template>

    </vx-card>

  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
export default {
  data: () => ({
    selected_other_field: [],
    grade_options: [],
    checkedFields: [],
    user_id: null,
    abilities: null,
    selected_campaign: null,
    campaignDescription: [],
    review_changes: null,
  }),
  components: {
    "v-select": vSelect,
  },
  watch: {},
  methods: {
    reviewerAccepted(changes) {
      let self = this;
      let data = {};
      data.uuid = changes['uuid'];
      data.reviewer_id = self.user_id
      data.changes = changes
      this.$store
        .dispatch("campaignsManagement/reviewerAccepted", data)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Data Changes",
              text: res.data.message
            });
            this.getCampaignOtherFieldData()
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerRejected(changes) {
      let self = this;
      let data = {};
      data.uuid = changes['uuid'];
      data.reviewer_id = self.user_id
      data.changes = changes
      // data.key = key
      // if (data.key == 'phone_no' || data.key == 'url' || data.key == 'url' || data.key == 'contact_ddi' || data.key == 'contact_email' || data.key == 'contact_mobile' || data.key == 'contact_social_media') {

      //   if (val[key] == 'EMPTY' || val[key] == '') {
      //     data.changes['field'] = null;
      //   } else {
      //     if (!Array.isArray(val[key])) {
      //       data.val = val[key].split(",");
      //     } else {
      //       data.val = val[key];
      //     }
      //   }
      // } else {
      //   if (val[key] == 'EMPTY') {
      //     data.val = null;
      //   } else {
      //     data.val = val[key];
      //   }

      // }
      this.$store
        .dispatch("campaignsManagement/reviewerRejected", data)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Data Changes",
              text: res.data.message
            });
            this.getCampaignOtherFieldData()
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    // reviewerRejectOnContact(val, key, new_val) {

    //   let self = this;
    //   let data = {};
    //   data.campaign_id = self.$route.params.campaignId;
    //   data.key = key;
    //   data.qc_history_id = new_val['qc_history_id'];
    //   data.reviewer_id = self.user_id
    //   data.data_changed_on = 'contact'
    //   data.id = val['id'];
    //   if (data.key == 'contact_ddi' || data.key == 'contact_email' || data.key == 'contact_mobile' || data.key == 'contact_social_media') {

    //     if (val[key] == 'EMPTY' || val[key] == '') {
    //       data.val = null;
    //     } else {
    //       if (!Array.isArray(val[key])) {
    //         data.val = val[key].split(",");
    //       } else {
    //         data.val = val[key];
    //       }

    //     }
    //   } else {
    //     if (val[key] == 'EMPTY') {
    //       data.val = null;
    //     } else {
    //       data.val = val[key];
    //     }

    //   }
    //   this.$store
    //     .dispatch("campaignsManagement/reviewerRejected", data)
    //     .then(res => {
    //       if (res.data.status == "success") {
    //         this.$vs.notify({
    //           color: "success",
    //           title: "Data Changes",
    //           text: res.data.message
    //         });
    //         this.getCampaignOtherFieldData()
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getCampaignOtherFieldData() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      this.selected_other_field.push(atob(this.$route.params.otherFields))

      // console.log(JSON.parse(atob(this.$route.params.otherFields)))

      data.selected_other_field = JSON.parse(atob(this.$route.params.otherFields))
      this.$store
        .dispatch("campaignsManagement/getCampaignOtherFieldData", data)
        .then(res => {

          this.review_changes = res.data;
          this.review_changes = this.review_changes.filter(ele => ele[data.selected_other_field][0] != null)

          //   Object.keys(el).forEach((key) => {

          //     if (typeof el[key] === 'string' || el[key] instanceof String) {
          //       if (el[key].startsWith('[') && el[key] != '[]') {


          //         el[key] = JSON.parse(el[key])
          //         el[key] = el[key].toString()
          //       }


          //     }
          //     if (el[key] == null || el[key] == '' || el[key] == '[]') {
          //       if (key != 'reviewer_accepted' && key != 'reviewer_id' && key != 'updated') {
          //         el[key] = 'EMPTY'
          //       }
          //     }


          //     if (key == 'ddi') {
          //       el[key] = el['contact_ddi']
          //     }

          //     if (key == 'email') {
          //       el[key] = el['contact_email']
          //     }

          //     if (key == 'mobile') {
          //       el[key] = el['contact_mobile']
          //     }

          //     if (key == 'social_media') {
          //       el[key] = el['contact_social_media']
          //     }

          //     if (key == 'website') {
          //       el[key] = el['url']
          //     }

          //     if (key == 'linkedin') {
          //       el[key] = el['url']
          //     }

          //     if (key == 'phone') {
          //       el[key] = el['phone_no']
          //     }


          //   });

          // })


          // this.review_changes.forEach((ele) => {

          //   if(ele.field_type == 'checkbox_columns'){
          //     ele.field_value = ele.field_value.split(",")
          //     // let new_array = []
          //     // array_values.forEach(function(e){
          //     //   new_array.push({value : e})
          //     // })
          //     // ele.field_value = new_array
          //   }
          //   return ele
          // });

          // console.log(this.review_changes)

          // // const eachCons = (array, num) => {
          // //   return Array.from({ length: array.length - num + 1 },
          // //     (_, i) => array.slice(i, i + num))
          // // }

          // // let new_array = []
          // // this.review_changes.forEach(function (e) {
          // //   new_array.push(eachCons(e, 2))
          // // })

          // // this.review_changes = new_array


          // // // console.log(this.review_changes)



          // // this.review_changes.forEach(function (ele) {
          // //   ele.forEach(function (e,index) {

          // //     // find keys 
          // //     let keyObj1 = Object.keys(e[0]);
          // //     let keyObj2 = Object.keys(e[1]);

          // //     // find values 
          // //     let valueObj1 = Object.values(e[0]);
          // //     let valueObj2 = Object.values(e[1]);

          // //     // find max length to iterate	 
          // //     if (keyObj1.length > keyObj2.length) {
          // //       var biggestKey = keyObj1.length;
          // //     } else {
          // //       var biggestKey = keyObj2.length;
          // //     }

          // //     // now compare their keys and values  
          // //     for (var i = index; i < biggestKey; i++) {
          // //       if (keyObj1[i] == keyObj2[i] && valueObj1[i] == valueObj2[i]) {

          // //         console.log("First", valueObj1[i]);
          // //         console.log("Second", valueObj2[i]);

          // //         if (valueObj1[i] == valueObj2[i]) {

          // //           console.log(e)



          // //           console.log("KEY" , keyObj1[i]);
          // //                               // delete e[0][keyObj1[i]];
          // //                               //   delete e[1][keyObj1[i]];








          // //                     //   delete e[0][keyObj1[i]];
          // //         //   delete e[1][keyObj2[i]];

          // //         }


          // //         // if (keyObj1[i] !== 'id' && keyObj1[i] !== 'company_name' && keyObj1[i] != 'forename' && keyObj1[i] != 'surname' && keyObj1[i] != 'job_title' && keyObj1[i] != 'account_id') {
          // //         //   delete e[0][keyObj1[i]];
          // //         //   delete e[1][keyObj2[i]];
          // //         //   // delete e[0]['reviewer_accepted']
          // //         //   // delete e[1]['reviewer_accepted']
          // //         //   // delete e[0]['reviewer_id']
          // //         //   // delete e[1]['reviewer_id']
          // //         //   // delete e[0]['updated']
          // //         //   // delete e[1]['updated']
          // //         //   // delete e[0]['created_at']
          // //         //   // delete e[1]['created_at']
          // //         // }




          // //       } else {

          // //         // console.log("key 1 " , keyObj1[i])
          // //         //       console.log("key 2" , keyObj2[i])

          // //         // it prints keys have different values 
          // //         // console.log('KEY:' + keyObj2[i] + '   myObj1 value: ' + valueObj1[i] + '    myObj2 value: ' + valueObj2[i] + '\n');
          // //       }
          // //     }














          // //   })
          // // })

          // // let walk = (node1, node2) => {
          // //   // different types, return false
          // //   // if (typeof node1 !== typeof node2) return false
          // //   if (node1 && node2 && typeof node1 === 'object') {
          // //     const keys = Object.keys(node1)
          // //     return keys.length !== Object.keys(node2).length &&
          // //       keys.every(k => walk(node1[k], node2[k]))
          // //   }
          // //   return node1 !== node2
          // // }

          // // this.review_changes.forEach(function (ele) {

          // //   ele.forEach(function (e) {




          // //     e.forEach(function (el) {

          // //       Object.keys(el).forEach((key) => {

          // //         if (typeof el[key] === 'string' || el[key] instanceof String) {
          // //           if (el[key].startsWith('[') && el[key] != '[]') {


          // //             el[key] = JSON.parse(el[key])
          // //             el[key] = el[key].toString()
          // //           }


          // //         }
          // //         if (el[key] == null || el[key] == '' || el[key] == '[]') {
          // //           if (key != 'reviewer_accepted' && key != 'reviewer_id' && key != 'updated') {
          // //             el[key] = 'EMPTY'
          // //           }
          // //         }
          // //       });

          // //     })

          // //     let duplicated_prop = Object.keys(e[0]).filter((key) => !walk(e[0][key], e[1][key]))
          // //     e['duplicated_prop'] = duplicated_prop


          // //   })



          // // })

          // // let neww_arr = []

          // // this.review_changes.forEach(function (ele) {

          // //   ele.forEach(function (e) {

          // //     if (e[1]['reviewer_accepted'] == null) {

          // //       neww_arr.push(e)

          // //     }





          // //   })



          // // })

          // // this.review_changes = neww_arr

          // // console.log("sdfdf", neww_arr)



        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
  },
  mounted() {
    this.getCampaignDescription()
    this.getCampaignOtherFieldData()

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }


    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}


.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.accept-button {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

.dropdown_class {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 500px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  position: relative;
  font-family: inherit;
  height: 35px;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
